import React from "react";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faShare } from "@fortawesome/free-solid-svg-icons";

const RegisteredUserActionButton = ({
  id,
  status,
  setUserId,
  toggleShowModal,
  toggleShowResend,
}) => {
  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"View"}>
          <span>
            <FontAwesomeIcon
              onClick={() => {
                toggleShowModal();
                setUserId(id);
              }}
              icon={faEye}
              size="1x"
              data-toggle="modal"
              data-target="#businessDetail"
            />
          </span>
        </CustomTooltip>
        {status !== 1 && (
          <>
            <span>/</span>
            <CustomTooltip message={"Resend Email Verification"}>
              <span>
                <FontAwesomeIcon
                  icon={faShare}
                  size="1x"
                  onClick={() => {
                    setUserId(id);
                    toggleShowResend();
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        )}
      </span>
    </>
  );
};

export default RegisteredUserActionButton;
